import { useEffect, useState } from 'react';
import { Search } from 'lucide-react';

import ContextSwitchers from './ContextSwitchers';
import UserMenu from './UserMenu';
import CommandPalette from './CommandPalette';
import ThemeToggle from './ThemeToggle';

const Topbar = () => {
  const [paletteOpen, setPaletteOpen] = useState(false);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault();
        setPaletteOpen((v) => !v);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <header
      style={{
        height: 'var(--shell-topbar-h)',
        flexShrink: 0,
        background: 'var(--shell-bg-surface)',
        borderBottom: '1px solid var(--shell-border-subtle)',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '0 16px',
      }}
    >
      {/* Левая часть: контекст (проект + роль) */}
      <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
        <ContextSwitchers />
      </div>

      {/* Спейсер */}
      <div style={{ flex: 1 }} />

      {/* Правая часть: поиск + аватарка */}
      <button
        type="button"
        onClick={() => setPaletteOpen(true)}
        title="Поиск по разделам"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          height: 32,
          padding: '0 10px',
          borderRadius: 'var(--shell-radius-md)',
          border: '1px solid var(--shell-border-subtle)',
          background: 'var(--shell-bg-subtle)',
          color: 'var(--shell-text-secondary)',
          fontSize: 12,
          cursor: 'pointer',
          minWidth: 180,
          transition:
            'background var(--shell-transition-fast), border-color var(--shell-transition-fast)',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'var(--shell-bg-hover)';
          e.currentTarget.style.borderColor = 'var(--shell-border-default)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'var(--shell-bg-subtle)';
          e.currentTarget.style.borderColor = 'var(--shell-border-subtle)';
        }}
      >
        <Search size={14} strokeWidth={1.75} />
        <span style={{ flex: 1, textAlign: 'left' }}>Поиск</span>
        <kbd
          style={{
            padding: '1px 5px',
            fontSize: 10,
            border: '1px solid var(--shell-border-default)',
            borderRadius: 4,
            background: 'var(--shell-bg-surface)',
            color: 'var(--shell-text-secondary)',
            fontFamily: 'inherit',
          }}
        >
          ⌘K
        </kbd>
      </button>

      <ThemeToggle />

      <UserMenu />

      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
    </header>
  );
};

export default Topbar;
